module.exports = __webpack_public_path__ + "img/datahub-4.6d3a62dd.png";